import React, { Component } from 'react';
import Head from 'next/head'
import { Header, Footer, PageWrapper, PinMap } from '../components'
import { fetchVenues } from '../api/venues'

class MapPage extends Component {
  static async getInitialProps({props}) {
    const venues = await fetchVenues(props.organisationId)

    return {
        organisationId: props.organisationId,
        venues: venues.data
    }
  }

  constructor(props) {
    super(props)
    this.state = {
        lng: -3.435973,
        lat: 55.378051
      }

    this.locationSuccess = this.locationSuccess.bind(this)
  }

  locationSuccess(pos) {
    var crd = pos.coords;
      
    this.setState({
        lng:crd.longitude,
        lat:crd.latitude
    })
  }

  componentDidMount() {
    var options = {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0,
    };
      
    function errors(err) {
    }
    const self = this
    if (navigator.permissions && navigator.geolocation) {
        navigator.permissions
          .query({ name: "geolocation" })
          .then(function (result) {
            if (result.state === "granted") {
              //If granted then you can directly call your function here
              navigator.geolocation.getCurrentPosition(self.locationSuccess);
            } else if (result.state === "prompt") {
              navigator.geolocation.getCurrentPosition(self.locationSuccess, errors, options);
            } else if (result.state === "denied") {
              //If denied then you have to show instructions to enable location
            }
          });
      }
  }

  render() {
    const { organisationId, organisation, venues, pages } = this.props
    const { lng, lat } = this.state
    return (
      <div className={`u-grid u-grid--basic u-grid-${organisationId}`}>
        <Head>
          <title>{`${organisation.name} | News `}</title>
          <meta property="og:title" content={`BRHA | News`} />
          <meta property="og:description" content="Latest BRHA news."/>
          <meta property="og:image" content="https://brha.co/static/photo.png" />
        </Head>
        <Header region={organisation.name} regionId={organisation.id} pages={pages}/>
        <div className="u-grid__main">
            <PinMap lat={lat} lng={lng}
                venues={venues} 
                onPlacesChanged={this.onPlacesChanged}
                onSearchBoxMounted={this.onSearchBoxMounted}/>
        </div>
        <Footer regionId={organisation.id}/>
      </div>
    )
  }

}
export default PageWrapper(MapPage)
